import './RevenueStationaryTable.css'

import PropTypes from 'prop-types'
import React, { useRef } from 'react'
import { FixedSizeList as List } from 'react-window'
import useSyncScroll from 'utils/useSyncScroll'

import RevenueStationaryTableHeader from './RevenueStationaryTableHeader'
import RevenueStationaryTableRow from './RevenueStationaryTableRow'

const RevenueStationaryTable = ({
  dataSourceVisibility,
  displayChannel,
  headerClassName,
  itemHeight,
  listHeight,
  maxRevenue,
  onFilter,
  onScroll,
  scrollOffset,
  showModal,
  sortBy,
  stores,
  type,
}) => {
  const listRef = useRef()

  useSyncScroll(listRef, scrollOffset)

  return (
    <div aria-label="revenue" className="revenue-table" role="table">
      <RevenueStationaryTableHeader
        className={headerClassName}
        dataSourceVisibility={dataSourceVisibility}
        onFilter={onFilter}
        sortBy={sortBy}
        type={type}
      />

      <List
        useIsScrolling
        className="revenue-stationary-table-row"
        height={listHeight}
        itemCount={stores.length}
        itemData={{
          dataSourceVisibility,
          displayChannel,
          maxRevenue,
          showModal,
          stores,
          type,
        }}
        itemSize={itemHeight}
        onScroll={onScroll}
        overscanCount={8}
        ref={listRef}
        width="100%"
      >
        {RevenueStationaryTableRow}
      </List>
    </div>
  )
}

RevenueStationaryTable.propTypes = {
  dataSourceVisibility: PropTypes.bool,
  displayChannel: PropTypes.bool,
  headerClassName: PropTypes.string,
  itemHeight: PropTypes.number,
  listHeight: PropTypes.number,
  maxRevenue: PropTypes.number,
  onFilter: PropTypes.func,
  onScroll: PropTypes.func,
  scrollOffset: PropTypes.number,
  showModal: PropTypes.func,
  sortBy: PropTypes.object,
  stores: PropTypes.array,
  type: PropTypes.string,
}

export default RevenueStationaryTable
